import { API_URL } from 'constants';

export const LOGIN_URL = `${API_URL}/api/v1/auth/login`;
export const REFRESH_TOKEN_URL = `${API_URL}/api/v1/auth/refresh-token`;
